import type { Application } from "@hotwired/stimulus";
import morphdom from "morphdom";

function nextEventLoopTick() {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), 0));
}

function getNodeKey(node: Node) {
  if (node && node instanceof HTMLElement) {
    return node.getAttribute && node.getAttribute("id");
  }
  if ("id" in node) return node.id;
}

export async function render(
  currentElement: HTMLElement,
  newElement: HTMLElement,
  application: Application
) {
  // avoid race condition in Turbo
  await nextEventLoopTick();

  application.controllers.map((controller) => controller.disconnect());
  await nextEventLoopTick();

  morphdom(currentElement, newElement, {
    getNodeKey,
  });
  await nextEventLoopTick();

  application.controllers.map((controller) => controller.connect());
}

export async function renderFrame(
  currentElement: HTMLElement,
  newElement: HTMLElement,
  application: Application
) {
  // avoid race condition in Turbo
  await nextEventLoopTick();

  application.controllers
    .filter((controller) => currentElement.contains(controller.element))
    .map((controller) => controller.disconnect());
  await nextEventLoopTick();

  morphdom(currentElement, newElement, {
    getNodeKey,
    childrenOnly: true,
  });
  await nextEventLoopTick();

  application.controllers
    .filter((controller) => currentElement.contains(controller.element))
    .map((controller) => controller.connect());
}
